import { render } from "./PurgedUsers.vue?vue&type=template&id=168f2600"
import script from "./PurgedUsers.vue?vue&type=script&lang=js"
export * from "./PurgedUsers.vue?vue&type=script&lang=js"

import "./PurgedUsers.vue?vue&type=style&index=0&id=168f2600&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__